document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const bisTrigger = document.querySelector('#BIS_trigger')
    const bisFrame = document.querySelector('#BIS_frame')
    const bisFrameBody = bisFrame?.contentDocument?.body

    bisTrigger?.addEventListener('click', function () {
      document.body.classList.add('bis-open')
    })

    bisFrameBody?.addEventListener('click', function (event) {
      if (
        event.target.tagName.toLowerCase() === 'body' ||
        event.target.classList.contains('action-close')
      ) {
        document.body.classList.remove('bis-open')
      }
    })
  }, 1000)
})
